module.exports = __webpack_public_path__ + "static/media/Ruizi Wang.fb929574.png";